<template>
    <footer>
        <a
            v-if="!props.nobranding"
            id="asknicely-logo"
            :href="props.referrerUrl"
            target="_blank"
        >
            <img
                class="powered-by-b"
                src="../../../../assets/img/powered-by-asknicely.png"
                alt="Go to AskNicely website to learn more about our product"
            />
        </a>
        <span class="google">This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a>
            and
            <a href="https://policies.google.com/terms">Terms of Service</a>
            apply.
        </span>
    </footer>
</template>

<script setup lang="ts">
type Props = {
    nobranding?: any // TODO: Fix type definition of Params on parent
    referrerUrl?: string
}
const props = defineProps<Props>()
</script>

<style>
footer {
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    align-items: center;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding-top: 15px;
    padding-bottom: 15px;

    #asknicely-logo {
        height: 24px;
        img.powered-by-b {
            width: 173px;
            height: 24px;
        }
    }
    .google {
        text-align: center;
        font-size: 12px;
        padding-top: 30px;
        color: #6e6969;
        a {
            color: #6e6969;
        }
    }
}
</style>
